import { default as _91slug_93DiFLNZWn1dMeta } from "/app/src/pages/[category]/[slug].vue?macro=true";
import { default as batch9VsbC09PbHMeta } from "/app/src/pages/admin/batch.vue?macro=true";
import { default as cachefYhALBPDzCMeta } from "/app/src/pages/admin/cache.vue?macro=true";
import { default as batchN3Ca6c8KPqMeta } from "/app/src/pages/auth/admin/batch.vue?macro=true";
import { default as emailVerifiedv94ORYu4hXMeta } from "/app/src/pages/auth/emailVerified.vue?macro=true";
import { default as forgottenPassword82GbNUw2PNMeta } from "/app/src/pages/auth/forgottenPassword.vue?macro=true";
import { default as loginOk5zcM8cXjMeta } from "/app/src/pages/auth/login.vue?macro=true";
import { default as confirmJ4IEiTGxPEMeta } from "/app/src/pages/auth/register/confirm.vue?macro=true";
import { default as indexwOyh5CkCgVMeta } from "/app/src/pages/auth/register/index.vue?macro=true";
import { default as Anonda8CPwUwTfMeta } from "/app/src/pages/auth/resetPassword/Anon.vue?macro=true";
import { default as Auth8yXXTpoi4fMeta } from "/app/src/pages/auth/resetPassword/Auth.vue?macro=true";
import { default as confirmMC2P8Pz1ccMeta } from "/app/src/pages/auth/resetPassword/confirm.vue?macro=true";
import { default as updatePasswordLZKEga4gVVMeta } from "/app/src/pages/auth/updatePassword.vue?macro=true";
import { default as actionstTc3xGF45jMeta } from "/app/src/pages/baserow/actions.vue?macro=true";
import { default as events09Oe5oiXzRMeta } from "/app/src/pages/baserow/events.vue?macro=true";
import { default as fundingsTtdQ7t9LnMeta } from "/app/src/pages/baserow/funding.vue?macro=true";
import { default as inspirationsXj80mZUqqPMeta } from "/app/src/pages/baserow/inspirations.vue?macro=true";
import { default as newsKj9AVmhfXyMeta } from "/app/src/pages/baserow/news.vue?macro=true";
import { default as servicesITRQXdomVTMeta } from "/app/src/pages/baserow/services.vue?macro=true";
import { default as badgeszUWan1Wc7zMeta } from "/app/src/pages/design/badges.vue?macro=true";
import { default as buttonsdJDVbfM8VoMeta } from "/app/src/pages/design/buttons.vue?macro=true";
import { default as colorszzPHnuCWN5Meta } from "/app/src/pages/design/colors.vue?macro=true";
import { default as disciplinesYG5PejDgsSMeta } from "/app/src/pages/design/disciplines.vue?macro=true";
import { default as federationsyXbNoJjS8HMeta } from "/app/src/pages/design/federations.vue?macro=true";
import { default as iconsrMLlSHSlgUMeta } from "/app/src/pages/design/icons.vue?macro=true";
import { default as indexoOBjfDITAHMeta } from "/app/src/pages/design/index.vue?macro=true";
import { default as inputsFsM0TOBwgzMeta } from "/app/src/pages/design/inputs.vue?macro=true";
import { default as typographyHtj86ckNVXMeta } from "/app/src/pages/design/typography.vue?macro=true";
import { default as indexdPwi6hPdMfMeta } from "/app/src/pages/index.vue?macro=true";
import { default as a11yhFopYohmqyMeta } from "/app/src/pages/legal/a11y.vue?macro=true";
import { default as cgurA1cJuZqLZMeta } from "/app/src/pages/legal/cgu.vue?macro=true";
import { default as cookiesoXGsX3xpHBMeta } from "/app/src/pages/legal/cookies.vue?macro=true";
import { default as rgpdkpqUyfR6CzMeta } from "/app/src/pages/legal/rgpd.vue?macro=true";
import { default as presentationX6vlvX2iZPMeta } from "/app/src/pages/presentation.vue?macro=true";
import { default as search5UN5dWklNeMeta } from "/app/src/pages/search.vue?macro=true";
import { default as sengagerrxTUC9CZZjMeta } from "/app/src/pages/sengager.vue?macro=true";
import { default as unauthorizedGn8hmlQpJjMeta } from "/app/src/pages/unauthorized.vue?macro=true";
import { default as compteHP3WtS6wulMeta } from "/app/src/pages/utilisateur/parametres/compte.vue?macro=true";
import { default as editEmail8zXdKNbKZfMeta } from "/app/src/pages/utilisateur/parametres/editEmail.vue?macro=true";
import { default as editPassword0ipwHBZDLUMeta } from "/app/src/pages/utilisateur/parametres/editPassword.vue?macro=true";
import { default as editUserInfog73eu25ni2Meta } from "/app/src/pages/utilisateur/parametres/editUserInfo.vue?macro=true";
import { default as ressourcesFSf0Or0xkMMeta } from "/app/src/pages/utilisateur/ressources/ressources.vue?macro=true";
import { default as ContactsComponentVJdkcXYm8LMeta } from "/app/src/pages/utilisateur/structures/edit/ContactsComponent.vue?macro=true";
import { default as edit03ChRhWR1HMeta } from "/app/src/pages/utilisateur/structures/edit/edit.vue?macro=true";
import { default as EditComponentrV8x2JD1cjMeta } from "/app/src/pages/utilisateur/structures/edit/EditComponent.vue?macro=true";
import { default as ViewComponentH1Moan1eeRMeta } from "/app/src/pages/utilisateur/structures/edit/ViewComponent.vue?macro=true";
import { default as structuresq8EsRHMSohMeta } from "/app/src/pages/utilisateur/structures/structures.vue?macro=true";
import { default as viewGUoWdeheQTMeta } from "/app/src/pages/utilisateur/structures/view/view.vue?macro=true";
import { default as component_45stubnO9MU04yTUMeta } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubnO9MU04yTU } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "category-slug___fr-FR",
    path: "/:category()/:slug()",
    meta: _91slug_93DiFLNZWn1dMeta || {},
    component: () => import("/app/src/pages/[category]/[slug].vue").then(m => m.default || m)
  },
  {
    name: "admin-batch___fr-FR",
    path: "/admin/batch",
    meta: batch9VsbC09PbHMeta || {},
    component: () => import("/app/src/pages/admin/batch.vue").then(m => m.default || m)
  },
  {
    name: "admin-cache___fr-FR",
    path: "/admin/cache",
    meta: cachefYhALBPDzCMeta || {},
    component: () => import("/app/src/pages/admin/cache.vue").then(m => m.default || m)
  },
  {
    name: "auth-admin-batch___fr-FR",
    path: "/admin/batch",
    meta: batchN3Ca6c8KPqMeta || {},
    component: () => import("/app/src/pages/auth/admin/batch.vue").then(m => m.default || m)
  },
  {
    name: "auth-emailVerified___fr-FR",
    path: "/auth/email-verifie",
    meta: emailVerifiedv94ORYu4hXMeta || {},
    component: () => import("/app/src/pages/auth/emailVerified.vue").then(m => m.default || m)
  },
  {
    name: "auth-forgottenPassword___fr-FR",
    path: "/auth/oubli-mot-de-passe",
    meta: forgottenPassword82GbNUw2PNMeta || {},
    component: () => import("/app/src/pages/auth/forgottenPassword.vue").then(m => m.default || m)
  },
  {
    name: "auth-login___fr-FR",
    path: "/auth/connexion",
    meta: loginOk5zcM8cXjMeta || {},
    component: () => import("/app/src/pages/auth/login.vue").then(m => m.default || m)
  },
  {
    name: "auth-register-confirm___fr-FR",
    path: "/auth/inscription/confirmation",
    meta: confirmJ4IEiTGxPEMeta || {},
    component: () => import("/app/src/pages/auth/register/confirm.vue").then(m => m.default || m)
  },
  {
    name: "auth-register___fr-FR",
    path: "/auth/inscription",
    meta: indexwOyh5CkCgVMeta || {},
    component: () => import("/app/src/pages/auth/register/index.vue").then(m => m.default || m)
  },
  {
    name: "auth-resetPassword-Anon___fr-FR",
    path: "/auth/reset/mot-de-passe",
    meta: Anonda8CPwUwTfMeta || {},
    component: () => import("/app/src/pages/auth/resetPassword/Anon.vue").then(m => m.default || m)
  },
  {
    name: "auth-resetPassword-Auth___fr-FR",
    path: "/auth/forced-reset/mot-de-passe",
    meta: Auth8yXXTpoi4fMeta || {},
    component: () => import("/app/src/pages/auth/resetPassword/Auth.vue").then(m => m.default || m)
  },
  {
    name: "auth-resetPassword-confirm___fr-FR",
    path: "/auth/reset/confirmation",
    meta: confirmMC2P8Pz1ccMeta || {},
    component: () => import("/app/src/pages/auth/resetPassword/confirm.vue").then(m => m.default || m)
  },
  {
    name: "auth-updatePassword___fr-FR",
    path: "/auth/maj-mot-de-passe",
    meta: updatePasswordLZKEga4gVVMeta || {},
    component: () => import("/app/src/pages/auth/updatePassword.vue").then(m => m.default || m)
  },
  {
    name: "baserow-actions___fr-FR",
    path: "/les-actions",
    meta: actionstTc3xGF45jMeta || {},
    component: () => import("/app/src/pages/baserow/actions.vue").then(m => m.default || m)
  },
  {
    name: "baserow-events___fr-FR",
    path: "/les-evenements",
    meta: events09Oe5oiXzRMeta || {},
    component: () => import("/app/src/pages/baserow/events.vue").then(m => m.default || m)
  },
  {
    name: "baserow-funding___fr-FR",
    path: "/les-financements",
    meta: fundingsTtdQ7t9LnMeta || {},
    component: () => import("/app/src/pages/baserow/funding.vue").then(m => m.default || m)
  },
  {
    name: "baserow-inspirations___fr-FR",
    path: "/sinspirer",
    meta: inspirationsXj80mZUqqPMeta || {},
    component: () => import("/app/src/pages/baserow/inspirations.vue").then(m => m.default || m)
  },
  {
    name: "baserow-news___fr-FR",
    path: "/les-actualites",
    meta: newsKj9AVmhfXyMeta || {},
    component: () => import("/app/src/pages/baserow/news.vue").then(m => m.default || m)
  },
  {
    name: "baserow-services___fr-FR",
    path: "/les-services",
    meta: servicesITRQXdomVTMeta || {},
    component: () => import("/app/src/pages/baserow/services.vue").then(m => m.default || m)
  },
  {
    name: "design-badges___fr-FR",
    path: "/design/badges",
    meta: badgeszUWan1Wc7zMeta || {},
    component: () => import("/app/src/pages/design/badges.vue").then(m => m.default || m)
  },
  {
    name: "design-buttons___fr-FR",
    path: "/design/buttons",
    meta: buttonsdJDVbfM8VoMeta || {},
    component: () => import("/app/src/pages/design/buttons.vue").then(m => m.default || m)
  },
  {
    name: "design-colors___fr-FR",
    path: "/design/colors",
    meta: colorszzPHnuCWN5Meta || {},
    component: () => import("/app/src/pages/design/colors.vue").then(m => m.default || m)
  },
  {
    name: "design-disciplines___fr-FR",
    path: "/design/disciplines",
    meta: disciplinesYG5PejDgsSMeta || {},
    component: () => import("/app/src/pages/design/disciplines.vue").then(m => m.default || m)
  },
  {
    name: "design-federations___fr-FR",
    path: "/design/federations",
    meta: federationsyXbNoJjS8HMeta || {},
    component: () => import("/app/src/pages/design/federations.vue").then(m => m.default || m)
  },
  {
    name: "design-icons___fr-FR",
    path: "/design/icons",
    meta: iconsrMLlSHSlgUMeta || {},
    component: () => import("/app/src/pages/design/icons.vue").then(m => m.default || m)
  },
  {
    name: "design___fr-FR",
    path: "/design",
    meta: indexoOBjfDITAHMeta || {},
    component: () => import("/app/src/pages/design/index.vue").then(m => m.default || m)
  },
  {
    name: "design-inputs___fr-FR",
    path: "/design/inputs",
    meta: inputsFsM0TOBwgzMeta || {},
    component: () => import("/app/src/pages/design/inputs.vue").then(m => m.default || m)
  },
  {
    name: "design-typography___fr-FR",
    path: "/design/typography",
    meta: typographyHtj86ckNVXMeta || {},
    component: () => import("/app/src/pages/design/typography.vue").then(m => m.default || m)
  },
  {
    name: "index___fr-FR",
    path: "/",
    meta: indexdPwi6hPdMfMeta || {},
    component: () => import("/app/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "legal-a11y___fr-FR",
    path: "/legal/declaration-daccessiblite",
    meta: a11yhFopYohmqyMeta || {},
    component: () => import("/app/src/pages/legal/a11y.vue").then(m => m.default || m)
  },
  {
    name: "legal-cgu___fr-FR",
    path: "/legal/cgu",
    meta: cgurA1cJuZqLZMeta || {},
    component: () => import("/app/src/pages/legal/cgu.vue").then(m => m.default || m)
  },
  {
    name: "legal-cookies___fr-FR",
    path: "/legal/cookies",
    meta: cookiesoXGsX3xpHBMeta || {},
    component: () => import("/app/src/pages/legal/cookies.vue").then(m => m.default || m)
  },
  {
    name: "legal-rgpd___fr-FR",
    path: "/legal/rgpd",
    meta: rgpdkpqUyfR6CzMeta || {},
    component: () => import("/app/src/pages/legal/rgpd.vue").then(m => m.default || m)
  },
  {
    name: "presentation___fr-FR",
    path: "/presentation",
    meta: presentationX6vlvX2iZPMeta || {},
    component: () => import("/app/src/pages/presentation.vue").then(m => m.default || m)
  },
  {
    name: "search___fr-FR",
    path: "/trouver-clubs-sportifs-engages",
    meta: search5UN5dWklNeMeta || {},
    component: () => import("/app/src/pages/search.vue").then(m => m.default || m)
  },
  {
    name: "sengager___fr-FR",
    path: "/sengager",
    meta: sengagerrxTUC9CZZjMeta || {},
    component: () => import("/app/src/pages/sengager.vue").then(m => m.default || m)
  },
  {
    name: "unauthorized___fr-FR",
    path: "/unauthorized",
    component: () => import("/app/src/pages/unauthorized.vue").then(m => m.default || m)
  },
  {
    name: "utilisateur-parametres-compte___fr-FR",
    path: "/utilisateur/compte",
    meta: compteHP3WtS6wulMeta || {},
    component: () => import("/app/src/pages/utilisateur/parametres/compte.vue").then(m => m.default || m)
  },
  {
    name: "utilisateur-parametres-editEmail___fr-FR",
    path: "/utilisateur/parametres/editEmail",
    component: () => import("/app/src/pages/utilisateur/parametres/editEmail.vue").then(m => m.default || m)
  },
  {
    name: "utilisateur-parametres-editPassword___fr-FR",
    path: "/utilisateur/parametres/editPassword",
    component: () => import("/app/src/pages/utilisateur/parametres/editPassword.vue").then(m => m.default || m)
  },
  {
    name: "utilisateur-parametres-editUserInfo___fr-FR",
    path: "/utilisateur/parametres/editUserInfo",
    component: () => import("/app/src/pages/utilisateur/parametres/editUserInfo.vue").then(m => m.default || m)
  },
  {
    name: "utilisateur-ressources-ressources___fr-FR",
    path: "/utilisateur/ressources",
    meta: ressourcesFSf0Or0xkMMeta || {},
    component: () => import("/app/src/pages/utilisateur/ressources/ressources.vue").then(m => m.default || m)
  },
  {
    name: "utilisateur-structures-edit-ContactsComponent___fr-FR",
    path: "/utilisateur/structures/edit/ContactsComponent",
    component: () => import("/app/src/pages/utilisateur/structures/edit/ContactsComponent.vue").then(m => m.default || m)
  },
  {
    name: "utilisateur-structures-edit-edit___fr-FR",
    path: "/utilisateur/structures/edit/:id/:step?",
    meta: edit03ChRhWR1HMeta || {},
    component: () => import("/app/src/pages/utilisateur/structures/edit/edit.vue").then(m => m.default || m)
  },
  {
    name: "utilisateur-structures-edit-EditComponent___fr-FR",
    path: "/utilisateur/structures/edit/EditComponent",
    component: () => import("/app/src/pages/utilisateur/structures/edit/EditComponent.vue").then(m => m.default || m)
  },
  {
    name: "utilisateur-structures-edit-ViewComponent___fr-FR",
    path: "/utilisateur/structures/edit/ViewComponent",
    component: () => import("/app/src/pages/utilisateur/structures/edit/ViewComponent.vue").then(m => m.default || m)
  },
  {
    name: "utilisateur-structures-structures___fr-FR",
    path: "/utilisateur/structures",
    meta: structuresq8EsRHMSohMeta || {},
    component: () => import("/app/src/pages/utilisateur/structures/structures.vue").then(m => m.default || m)
  },
  {
    name: "utilisateur-structures-view-view___fr-FR",
    path: "/utilisateur/structures/view/view",
    component: () => import("/app/src/pages/utilisateur/structures/view/view.vue").then(m => m.default || m)
  },
  {
    name: component_45stubnO9MU04yTUMeta?.name,
    path: "/appel-a-projet-fnce",
    component: component_45stubnO9MU04yTU
  },
  {
    name: component_45stubnO9MU04yTUMeta?.name,
    path: "/appel-a-projet-impact-2024",
    component: component_45stubnO9MU04yTU
  },
  {
    name: component_45stubnO9MU04yTUMeta?.name,
    path: "/du-stade-vers-lemploi",
    component: component_45stubnO9MU04yTU
  },
  {
    name: component_45stubnO9MU04yTUMeta?.name,
    path: "/les-clubs-sportifs-engages",
    component: component_45stubnO9MU04yTU
  },
  {
    name: component_45stubnO9MU04yTUMeta?.name,
    path: "/les-dispositifs",
    component: component_45stubnO9MU04yTU
  },
  {
    name: component_45stubnO9MU04yTUMeta?.name,
    path: "/action/service-civique",
    component: component_45stubnO9MU04yTU
  },
  {
    name: component_45stubnO9MU04yTUMeta?.name,
    path: "/tour-de-france-soutiens-ton-club-engage",
    component: component_45stubnO9MU04yTU
  },
  {
    name: component_45stubnO9MU04yTUMeta?.name,
    path: "/webinaires-de-presentation-appel-a-projet-fnce",
    component: component_45stubnO9MU04yTU
  },
  {
    name: component_45stubnO9MU04yTUMeta?.name,
    path: "/webinaires-par-region-presentation",
    component: component_45stubnO9MU04yTU
  },
  {
    name: component_45stubnO9MU04yTUMeta?.name,
    path: "/webinaires-thematiques-2eme-trimestre-2024",
    component: component_45stubnO9MU04yTU
  },
  {
    name: component_45stubnO9MU04yTUMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubnO9MU04yTU
  }
]